import React from "react";
import FormattedMessage from "components/FormattedMessage";
import { Button, Box, Flex } from "ui-components";
import map from "lodash/map";
import FAQItem from "components/FAQItem";
import PageHeader from "components/PageHeader";
import get from "lodash/get";
import isEmpty from "lodash/isEmpty";
import { iconThemes, getButtonColorVariant } from "ui-components/theme";
import { Text } from "ui-components/index";

const PageFaqs = ({
  title,
  faq,
  more,
  titleProps = {},
  buttonProps = {},
  messageData,
  themeColors
}) => {
  return isEmpty(faq) && isEmpty(more) ? null : (
    <Box variant="faqs" id="page-faqs">
      {title && (
        <Box padding="1.5rem" paddingBottom="0">
          <PageHeader
            title={title}
            themeColors={{ secondary: iconThemes.purple }}
            {...titleProps}
          />
        </Box>
      )}
      <Box padding="1.5rem" paddingBottom="0.5rem">
        <Box
          sx={{
            borderWidth: 1,
            borderStyle: "solid",
            borderColor: "gray.0",
            borderRadius: "16px",
            overflow: "hidden",
            backgroundColor: "#ffffff"
          }}
        >
          {/* Featured Header Banner */}
          <Box
            sx={{
              p: 2,
              backgroundColor: "#f0f7ff",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              cursor: "pointer"
            }}
          >
            <Text fontWeight={700} color="#111827">
              Will the numbers be under my Personal Name or under the Company? 
            </Text>
            <Text fontWeight={600} color="#111827" ml={2}>
              —
            </Text>
          </Box>

          {/* Featured Body Content */}
          <Box sx={{ p: 3 }}>
            <Text color="#374151" mb={3} lineHeight={1.5}>
              If you’ve signed up under this page, the numbers you have registered will be under the Company Name, please ensure the details are accurate upon signing up. The bill will reflect the Company Name that you have registered.
            </Text>
          </Box>
        </Box>
      </Box>
      {map(faq, (faq, index) => {
        return (
          <FAQItem
            key={index}
            {...faq}
            messageData={messageData}
            themeColors={themeColors}
          />
        );
      })}
      <Flex justifyContent="space-evenly" padding="1rem">
        {!isEmpty(more) && (
          <Button
            as="a"
            variant="outline"
            sx={getButtonColorVariant(themeColors?.button, "outline")}
            target="_blank"
            href={get(more, "link")}
            {...buttonProps}
          >
            <FormattedMessage id={get(more, "label")} />
          </Button>
        )}
      </Flex>
    </Box>
  );
};

PageFaqs.defaultProps = {
  title: "",
  faq: [],
  more: {},
  messageData: {}
};

export default PageFaqs;
